import { render, staticRenderFns } from "./TermsEn.vue?vue&type=template&id=37010220"
import script from "./TermsEn.vue?vue&type=script&lang=js"
export * from "./TermsEn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports